import { AffiliateMarketplaceInviteApi } from '@api';
import { marketplaceInviteTypes as actionTypes } from './types';

export const fetchMarketplaceInvites = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST.LOADING,
  });

  AffiliateMarketplaceInviteApi.getList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const createMarketplaceInvite = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.CREATE.LOADING,
  });

  AffiliateMarketplaceInviteApi.create({ affiliateMarketplaceInvite: params })
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.HYDRATE,
        payload: response,
        method: 'prepend',
      });

      dispatch({
        type: actionTypes.CREATE.SUCCESS,
        payload: response,
        message: 'created',
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.CREATE.FAILURE,
        payload: { data: error.data },
        message: `notify:general.save.error.${error.status}`,
      });
    });
};

export const previewMarketplaceInvite = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.PREVIEW.LOADING,
  });

  AffiliateMarketplaceInviteApi.preview({ affiliateMarketplaceInvite: params })
    .then((response) => {
      dispatch({
        type: actionTypes.PREVIEW.SUCCESS,
        payload: response,
        message: 'created',
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.PREVIEW.FAILURE,
        payload: { data: error.data },
        message: `notify:general.save.error.${error.status}`,
      });
    });
};
